import type { Theme } from "@/types/models";

const KEY = "lernapp.theme";

export function getTheme(): Theme {
  return (document.documentElement.dataset.theme as Theme) || "light";
}

export function setTheme(theme: Theme): void {
  document.documentElement.dataset.theme = theme;
  window.dispatchEvent(new CustomEvent<Theme>("app:themechange", { detail: theme }));
  try {
    localStorage.setItem(KEY, theme);
  } catch {
    /* localStorage evtl. nicht verfügbar */
  }
}

export function toggleTheme(): Theme {
  const next: Theme = getTheme() === "dark" ? "light" : "dark";
  setTheme(next);
  return next;
}
